import * as React from 'react'

import { AttachmentSupport } from '../domain/attachment-support'
import { AttachmentTranslations } from '../translations'

interface DropAreaProps {
  onAdd: (files: FileList) => void
  disabled?: boolean
  multiple?: boolean
  translations: AttachmentTranslations
}

const handleOnAdd =
  (onAdd: (files: FileList) => void) =>
  (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target
    if (!target || !target.files) {
      return
    }

    const files = target.files

    if (files.length > 0) {
      onAdd(files)
    }

    target.value = ''
  }

const stopPropagation = (e: any) => e.stopPropagation()
const stopAndPreventDefault = (e: any) => {
  e.preventDefault()
  e.stopPropagation()
}

class DropArea extends React.Component<DropAreaProps> {
  public componentDidMount() {
    document.body.addEventListener('drop', stopAndPreventDefault)
    document.body.addEventListener('dragover', stopAndPreventDefault)
  }

  public componentWillUnmount() {
    document.body.addEventListener('drop', stopAndPreventDefault)
    document.body.addEventListener('dragover', stopAndPreventDefault)
  }

  private createInputRef = (e: HTMLInputElement | null) => {
    if (e) {
      e.addEventListener('drop', stopPropagation)
      e.addEventListener('dragover', stopPropagation)
    }
  }

  public render() {
    const { disabled, onAdd, multiple } = this.props
    return (
      <div className="drop-area" data-qa="dropArea">
        <div className="drop-area-container">
          <h5 className="title is-3">{this.props.translations.title}</h5>
          <p className="info">
            {this.props.translations.generalInfo}
            {multiple === false && (
              <strong>
                {' '}
                {this.props.translations.singleFile}
              </strong>
            )}
            {'.'}
            <small className="drop-area-restrictions">
              {this.props.translations.restrictionsInfo}
            </small>
          </p>
          <input
            ref={this.createInputRef}
            className="drop-input"
            type="file"
            accept={AttachmentSupport.extensions.join(', ')}
            onChange={handleOnAdd(onAdd)}
            multiple={multiple !== false}
            disabled={!!disabled}
          />
        </div>
      </div>
    )
  }
}

export default DropArea
